<template>
  <div class="print-box tem p-1">
    <table class="prtable prtable-center prtable-bordered">
      <tr>
        <td colspan="2">
          <b>{{ manufacture.code }}</b>
        </td>
        <td colspan="2">
          <b v-if="manufacture.product">{{ manufacture.product.code }}</b>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          <span v-if="manufacture.product">{{ manufacture.product.name }}</span>
          <!-- <span v-if="manufacture.productCustom != ''"><br>{{ manufacture.productCustom }}</span> -->
          <b v-if="manufacture.reason"><br />{{ manufacture.reason.name }}</b>
        </td>
      </tr>
      <tr>
        <td colspan="2">{{ manufacture.colorCode1 }}</td>
        <td colspan="2">
          <b>{{ manufacture.colorText }}</b>
        </td>
      </tr>
      <tr>
        <td>
          <b v-if="manufacture.productSpecify">{{ manufacture.productSpecify.name }}</b>
        </td>
        <td>mm</td>
        <td>{{ manufacture.length }}</td>
        <td>cm</td>
      </tr>
      <tr>
        <td>
          <base-input v-if="isEdit" placeholder="g/M" v-model="Tem.gMet" :mask="'number'"></base-input>
          <span v-else>{{ $formatNumber(info.gMet) }}</span>
        </td>
        <td>
          <!-- <span v-if="manufacture.unit == 'Yarn'">
            G/Y
         </span>
         <span v-else-if="manufacture.unit == 'M'">
            G/M
         </span> -->
          G/{{ manufacture.unit }}
        </td>
        <td>
          <span v-if="isEdit">{{ $formatNumberFixed(Tem.mKg) }}</span>
          <span v-else>{{ $formatNumberFixed(info.mKg) }}</span>
        </td>
        <td>
          <span
            v-if="
              manufacture.unit && (manufacture.unit.toLowerCase() == 'yarn' || manufacture.unit.toLowerCase() == 'y')
            "
          >
            y/Kg
          </span>
          <span
            v-else-if="
              manufacture.unit && (manufacture.unit.toLowerCase() == 'met' || manufacture.unit.toLowerCase() == 'm')
            "
          >
            M/kg
          </span>
          <span
            v-else-if="
              manufacture.unit && (manufacture.unit.toLowerCase() == 'sợi' || manufacture.unit.toLowerCase() == 's')
            "
          >
            Sợi/Kg
          </span>
          <span v-else> {{ manufacture.unit }}/kg </span>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  name: 'tem-dh',
  props: {
    manufacture: {},
    code: {},
    Tem: {},
    info: {},
    quantityOdd: {},
    isOdd: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'Tem.gMet': function() {
      if (this.Tem.gMet != 0) {
        this.Tem.mKg = 1000 / this.Tem.gMet;
        this.$emit('change');
      } else {
        alert('Không thể chia cho 0');
      }
    }
  }
};
</script>
